module.exports = {
	"account.currentTime": "current date/time:",
	"account.delete.confirm": "Are you sure you want to delete your account?<br><span class='font-weight-bold text-danger'>This action is irreversible and will destroy all data associated with your account</span>.<br>This includes all of your missions, registrations as well as permissions granted to your account.",
	"account.delete.feedback.nickname": "The entered nickname does not exactly match your current nickname",
	"account.delete.nickname": "Enter the exact nickname of your account",
	"account.delete.nickname.description": "Please enter your current, exact nickname - including correct capitalisation - to confirm the deletion of your account",
	"account.feedback.nickname": "Please enter a nickname",
	"account.modal.delete": "Delete account",
	"account.modal.edit": "Edit account details",
	"account.noChanges": "No changes made to account details",
	"account.notAssociated": "not associated",
	"account.permission": "Permission",
	"account.permissions": "Permissions",
	"account.timezone": "Timezone",
	"button.accept": "Accept",
	"button.activate.user": "Activate account",
	"button.add": "Add",
	"button.add.mission.access": "Add access",
	"button.add.mission.permission": "Add permission",
	"button.apply": "Apply",
	"button.apply.mission.slotGroup": "Apply slot template",
	"button.apply.mission.slotGroup.short": "Apply",
	"button.assign": "Assign",
	"button.assign.mission.slot": "Assign slot",
	"button.cancel": "Cancel",
	"button.clear.selection": "Clear selection",
	"button.close": "Close",
	"button.confirm": "Confirm",
	"button.convert.slotTemplate": "Convert to slot template",
	"button.copy": "Copy",
	"button.create.community": "Create community",
	"button.create.community.permission": "Create permission",
	"button.create.mission": "Create mission",
	"button.create.mission.slot": "Create slot",
	"button.create.mission.slot.template": "Create slot template",
	"button.create.mission.slotGroup": "Create slot group",
	"button.deactivate.user": "Deactivate account",
	"button.delete": "Delete",
	"button.delete.account": "Delete account",
	"button.delete.mission.slot.selection": "Delete selected slots",
	"button.delete.user": "Delete user",
	"button.deny": "Deny",
	"button.details": "Details",
	"button.duplicate.mission": "Duplicate mission",
	"button.duplicate.mission.slot": "Duplicate slot",
	"button.duplicate.mission.slotGroup": "Duplicate slot group",
	"button.duplicate.mission.slotTemplate": "Duplicate slot template",
	"button.edit": "Edit",
	"button.edit.community.logo": "Edit logo",
	"button.edit.community.permissions": "Edit permissions",
	"button.edit.mission.accesses": "Edit access",
	"button.edit.mission.bannerImage": "Edit banner image",
	"button.edit.mission.permissions": "Edit permissions",
	"button.edit.mission.slot.selection": "Edit selected slots",
	"button.edit.mission.slotGroup": "Edit slot group",
	"button.embed.mission": "Embed mission",
	"button.export.calendar.google": "Google",
	"button.export.calendar.ical": "iCal",
	"button.generate": "Generate",
	"button.join": "Join",
	"button.move.down": "Move down",
	"button.move.up": "Move up",
	"button.refresh": "Refresh",
	"button.refresh.authentication": "Refresh authentication",
	"button.refresh.authentication.explanation": "You can refresh your authentication to make sure your account is updated with the correct permissions, community or likewise.<br>After being accepted to a community, a refresh is required before your account shows you as a community member and you can create community missions.",
	"button.register": "Register",
	"button.remove": "Remove",
	"button.save": "Save",
	"button.save.mission.slotTemplate.slotlist": "Save template slotlist",
	"button.submit": "Submit",
	"button.unassign": "Unassign",
	"button.unassign.mission.slot.selection": "Unassign selected slots",
	"button.unregister": "Unregister",
	"button.upload": "Upload",
	"calendar.month.current": "Today",
	"calendar.month.next": "Next",
	"calendar.month.previous": "Previous",
	"calendar.title": "Upcoming missions",
	"community.application.confirm.accept": "Accept application?",
	"community.application.confirm.deny": "Deny application?",
	"community.application.nickname": "Nickname",
	"community.application.status": "Status",
	"community.applications": "Applications",
	"community.applications.filter": "Filter - processed applications are hidden by default",
	"community.applications.filter.accepted": "accepted",
	"community.applications.filter.denied": "denied",
	"community.applications.filter.processed": "processed",
	"community.confirm.delete": "Delete community?",
	"community.creator.feedback.name": "Please enter a name",
	"community.creator.feedback.slug": "Enter a slug",
	"community.creator.feedback.slug.checking": "<em>Checking community slug availability...</em>",
	"community.creator.feedback.slug.notAvailable": "Community slug not available",
	"community.creator.feedback.tag": "Please enter a tag",
	"community.creator.feedback.website": "Please enter a valid website URL",
	"community.creator.title": "Create new community",
	"community.creator.title.browser": "Community creator",
	"community.gameServers": "Community gameservers",
	"community.gameServers.description": "You can select a gameserver defined for your community to quickly fill out the gameserver details above. Please note that this overwrites any data entered by you before",
	"community.gameServers.hostname.description": "Hostname/IP address of the gameserver to add to the community's list",
	"community.gameServers.name.description": "Name of the gameserver (e.g. in a server list) to add to the community's list. Leave empty if not relevant",
	"community.gameServers.password.description": "Password for the gameserver to add to the community's list. Leave empty if no password is required",
	"community.gameServers.port.description": "Port of the gameserver to add to the community's list",
	"community.leader": "Leader",
	"community.list.search": "Search communities",
	"community.list.search.description": "Start typing to search for a community with the given name, including partial matches. Clicking a community result will take you to its details page",
	"community.logo": "Logo",
	"community.logo.choose": "Choose file",
	"community.logo.description": "The logo is prominently displayed below the community name and above the community's information",
	"community.logo.feedback.fileType": "Invalid file type (only jpeg, png and gif are allowed)",
	"community.logo.feedback.size": "File too large (max. 2 MiB)",
	"community.logo.notSelected": "No logo selected",
	"community.member.confirm.remove": "Remove member?",
	"community.members": "Members",
	"community.modal.edit": "Edit community details",
	"community.modal.logo": "Edit logo",
	"community.modal.permission": "Community permissions",
	"community.name": "Name",
	"community.name.description": "Full name of the community",
	"community.noChanges": "No changes made to community details",
	"community.permission.create": "Create community permission",
	"community.permission.existing": "Existing community permissions",
	"community.permission.founder": "Community founder",
	"community.permission.leader": "Community leader",
	"community.permission.permission": "Permission to grant to user",
	"community.permission.permission.description": "Select the permission to grant to the user. <span class='font-weight-bold'>Community leaders</span> can modify your community's details as well as accept and remove members, but cannot delete the community or grant permissions to others. <span class='font-weight-bold'>Community recruitment</span> users can only accept community applications, but not remove members or edit any details.",
	"community.permission.recruitment": "Community recruitment",
	"community.permission.user.selection": "Search for user to grant permission to",
	"community.permission.user.selection.description": "Start typing to search for an user with the given nickname, including partial matches",
	"community.repositories": "Community mod repositories",
	"community.repositories.description": "You can select a mod repository defined for your community to quickly fill out the repo details above. Please note that this overwrites any data entered by you before",
	"community.slug": "Slug",
	"community.slug.description": "Slug to use for community URL, must be unique",
	"community.tag": "Tag",
	"community.tag.description": "Community tag to display for all members (prefixed before name)",
	"community.voiceComms": "Community voice comms",
	"community.voiceComms.description": "You can select a voice comms server defined for your community to quickly fill out the voice comms details above. Please note that this overwrites any data entered by you before",
	"community.voiceComms.hostname.description": "Hostname/IP address of the voice comms server to add to the community's list",
	"community.voiceComms.name.description": "Name of the voice comms server (e.g. in a server list) to add to the community's list. Leave empty if not relevant",
	"community.voiceComms.password.description": "Password for the voice comms server to add to the community's list. Leave empty if no password is required",
	"community.voiceComms.port.description": "Port of the voice comms server to add to the community's list",
	"community.website": "Website",
	"community.website.optional": "Website <em>(optional)</em>",
	"editor.explanation": "Click here for editor explanation",
	"editor.explanation.1": "Text size",
	"editor.explanation.2": "Headings",
	"editor.explanation.3": "Text color",
	"editor.explanation.4": "Bold/italic text",
	"editor.explanation.5": "Text alignment, text indentation",
	"editor.explanation.6": "Ordered & unordered lists",
	"editor.explanation.7": "Insert link, image or video",
	"editor.explanation.8": "Clear formatting",
	"editor.explanation.missing": "Some editor controls might be disabled or missing depending on the edited mission element",
	"failed.request": "Request failed",
	"failed.something": "Something failed...",
	"misc.actions": "Actions",
	"misc.notProvided": "not provided",
	"misc.notRequired": "not required",
	"misc.notSpecified": "not specified",
	"mission": "Mission",
	"mission.abbr.estimated": "est.",
	"mission.abbr.leadership": "ldrsp.",
	"mission.access.add": "Add mission access",
	"mission.access.add.explanation": "Choose communities or users that should have access to your mission and can register for slots.<br>By default, only you and all mission editors can see this mission - you will have to explicitly grant access to any other community or user.<br>Granting access to a community allows all members of this community to view the mission. Granting access to a single user only allows this user to view the mission.",
	"mission.access.community.selection": "Search for community to grant access to",
	"mission.access.community.selection.description": "Start typing to search for a community with the given name or tag, including partial matches. You can only grant a permission to either a community or an user, but not both simultaneously",
	"mission.access.existing": "Existing mission access",
	"mission.access.list.name": "Name",
	"mission.access.list.type": "Access type",
	"mission.access.list.type.community": "Community",
	"mission.access.list.type.user": "User",
	"mission.access.user.selection": "Search for user to grant access to",
	"mission.access.user.selection.description": "Start typing to search for an user with the given nickname, including partial matches. You can only grant a permission to either an user or a community, but not both simultaneously",
	"mission.apply.slotTemplate.description": "Apply a slot template to a mission, adding all defined slot groups at the selected position.<br>You can filter slot templates and select the desired template to apply.",
	"mission.bannerImage": "Banner image",
	"mission.bannerImage.choose": "Choose file",
	"mission.bannerImage.description": "The banner image is prominently displayed below the mission title and above the mission's description",
	"mission.bannerImage.feedback.fileType": "Invalid file type (only jpeg, png and gif are allowed)",
	"mission.bannerImage.feedback.size": "File too large (max. 2 MiB)",
	"mission.bannerImage.notSelected": "No banner image selected",
	"mission.briefingTime": "Briefing time",
	"mission.briefingTime.description": "Date and time the leadership briefing will be held",
	"mission.briefingTime.short": "Briefing",
	"mission.by": "by",
	"mission.collapsedDescription.description": "An optional, collapsed mission description can be used to provide even greater mission details and preparations to your players without having to scroll endlessly every time they want to check out the slotlist. This description is collapsed by default - only displaying a toggle button - and will be displayed after the mission's detailed description and before the slotlist",
	"mission.collapsedDescription.optional": "Collapsed mission description <em>(optional)</em>",
	"mission.collapsedDescription.toggle.close": "Collapse additional mission description",
	"mission.collapsedDescription.toggle.open": "Extend additional mission description",
	"mission.community": "Community",
	"mission.confirm.delete": "Delete mission?",
	"mission.convert.slotTemplate.description": "You can convert the current slotlist of this mission to a slot template, allowing you to reuse the configured slot groups and slots for other missions. Slot templates do not include community restrictions or slot assignments. Converting a mission to a slot template does not modify or delete the mission's slotlist in any way.<br>Choose a title and a visibility setting for the converted slot template.",
	"mission.creator": "Creator",
	"mission.creator.addToCommunity": "Add mission to community?",
	"mission.creator.addToCommunity.description": "Adding a mission to your community <strong>{communityInfo}</strong> makes it visible in the community's mission list",
	"mission.creator.title": "Create new mission",
	"mission.creator.title.browser": "Mission creator",
	"mission.description": "Description",
	"mission.description.description": "Description of the mission, providing a quick summary for the mission list",
	"mission.detailedDescription": "Detailed description",
	"mission.detailedDescription.description": "Detailed description of mission story, scenario, plot, tasks, etc. Everything your players should know before choosing to participate",
	"mission.details": "Mission details",
	"mission.duplicate.briefingTime.description": "New, optional briefing time to overwrite for duplicated mission - can be omitted",
	"mission.duplicate.description": "Choose a new slug to use for the duplicated mission.<br>You can also overwrite the mission's title, mission times as well as visibility and community settings.<br>All data omitted will be replaced by the original mission's values.",
	"mission.duplicate.endTime.description": "New, optional end time to overwrite for duplicated mission - can be omitted",
	"mission.duplicate.slottingTime.description": "New, optional slotting time to overwrite for duplicated mission - can be omitted",
	"mission.duplicate.slug.description": "Slug to use for duplicate mission",
	"mission.duplicate.startTime.description": "New, optional start time to overwrite for duplicated mission - can be omitted",
	"mission.duplicate.title.description": "New, optional title to overwrite for duplicated mission - can be omitted",
	"mission.duplicate.visibility.description": "Defines visibility of duplicated mission to other users, only allowing access to selected group",
	"mission.endTime": "End time",
	"mission.endTime.description": "Estimated date and time the mission will end at",
	"mission.feedback.dateTime": "Please enter a valid date and time",
	"mission.feedback.dateTime.afterSlotting": "Start time must be after slotting time",
	"mission.feedback.dateTime.afterStart": "End time must be after start time",
	"mission.feedback.description": "Please enter a short description",
	"mission.feedback.detailedDescription": "Please enter a detailed description",
	"mission.feedback.orderNumber": "Please enter an order number",
	"mission.feedback.repository.kind": "Please select a repository type",
	"mission.feedback.repository.name": "Please provide a repository name",
	"mission.feedback.repository.url": "Please provide a valid URL",
	"mission.feedback.repository.url.arma3sync": "Please provide a repository URL for an ArmA3Sync repository",
	"mission.feedback.repository.urlOrNotes": "Please provide at least either a repository URL or notes",
	"mission.feedback.serverInfo.hostnamePort": "Both hostname and port must be provided",
	"mission.feedback.serverInfo.portRange": "Port values must be between 0 and 65535",
	"mission.feedback.slot.autoAssignable.mission": "All slots will be created as auto-assignable since the mission's auto-assignable setting is enabled",
	"mission.feedback.slug": "Enter a slug",
	"mission.feedback.slug.checking": "<em>Checking mission slug availability...</em>",
	"mission.feedback.slug.notAvailable": "Mission slug not available",
	"mission.feedback.title": "Please enter a mission title",
	"mission.feedback.title.slot": "Please enter a slot title",
	"mission.feedback.title.slotGroup": "Please enter a slot group title",
	"mission.feedback.visibility": "Please select a visibility setting",
	"mission.gameServer": "Gameserver",
	"mission.gameServer.hostname.description": "Hostname/IP address of the gameserver the mission will be held on",
	"mission.gameServer.hostname.optional": "Gameserver hostname/IP <em>(optional)</em>",
	"mission.gameServer.name.description": "Name of the gameserver (e.g. in a server list) the mission will be held on. Leave empty if not relevant",
	"mission.gameServer.name.optional": "Gameserver name <em>(optional)</em>",
	"mission.gameServer.password.description": "Password for the gameserver the mission will be held on. Leave empty if no password is required",
	"mission.gameServer.password.optional": "Gameserver password <em>(optional)</em>",
	"mission.gameServer.port.description": "Port of the gameserver the mission will be held on",
	"mission.gameServer.port.optional": "Gameserver port <em>(optional)</em>",
	"mission.list.creator": "Creator",
	"mission.list.description": "Description",
	"mission.list.filter": "Filter - past missions are hidden by default",
	"mission.list.filter.assigned": "Missions with assigned slots",
	"mission.list.filter.ended": "Show past missions",
	"mission.list.filter.registered": "Missions with slot registrations",
	"mission.list.isMissionEditor": "You have editor permissions for this mission",
	"mission.list.search": "Search missions",
	"mission.list.search.description": "Start typing to search for a mission with the given title, including partial matches. Clicking a mission result will take you to its details page",
	"mission.list.slot.counts": "# of players",
	"mission.list.slot.counts.available": "Available slots",
	"mission.list.slot.counts.available.popover": "<strong>{open}</strong> slots are available to you",
	"mission.list.slot.counts.available.popover.community": "<strong>{open}</strong> slots are available to you and your fellow community members",
	"mission.list.slot.counts.popover": "<strong>{unassigned}</strong> slots have registrations, but have not been assigned yet. <strong>{assigned}</strong> slots have been assigned, <strong>{external}</strong> slots have been assigned to external players.<br>There are <strong>{blocked}</strong> blocked, <strong>{restricted}</strong> restricted and <strong>{reserve}</strong> reserve slots",
	"mission.list.slot.status": "Registration",
	"mission.list.slot.status.assigned": "Slot registration <span class='font-weight-bold text-success'>confirmed</span>, assigned to slot",
	"mission.list.slot.status.registered": "Slot registration <span class='font-weight-bold text-danger'>not confirmed</span>, not assigned to slot yet",
	"mission.list.startTime": "Start time",
	"mission.list.title": "Title",
	"mission.modal.access": "Mission access",
	"mission.modal.apply.slotTemplate": "Apply slot template to mission",
	"mission.modal.bannerImage": "Edit banner image",
	"mission.modal.convert.slotTemplate": "Convert mission to slot template",
	"mission.modal.duplicate": "Duplicate mission",
	"mission.modal.edit": "Edit mission",
	"mission.modal.embed": "Embed mission",
	"mission.modal.permission": "Mission permissions",
	"mission.modal.slot.assign": "Assign user to slot {slotInfo}",
	"mission.modal.slot.create": "Create slot in slot group",
	"mission.modal.slot.details": "Slot details",
	"mission.modal.slot.edit": "Edit slot",
	"mission.modal.slot.register": "Register for slot",
	"mission.modal.slot.register.text": "Confirm registration as {slotInfo}?",
	"mission.modal.slot.selection.edit": "Edit selected slots",
	"mission.modal.slotGroup.create": "Create slot group",
	"mission.modal.slotGroup.edit": "Edit slot group",
	"mission.permission.add": "Add mission permission",
	"mission.permission.creator": "Mission creator",
	"mission.permission.editor": "Mission editor",
	"mission.permission.existing": "Existing mission permissions",
	"mission.permission.permission": "Permission to grant to user",
	"mission.permission.permission.description": "Select the permission to grant to the user. <span class='font-weight-bold'>Mission editors</span> can modify your mission's details and slotlist, but cannot delete the mission or grant permissions to others. Users with the <span class='font-weight-bold'>Community slot manager</span> permission can assign and unassign registrations for slots restricted to their community, but cannot modify any other mission data or slot registrations",
	"mission.permission.slotlist.community": "Community slot manager",
	"mission.permission.user.selection": "Search for user to grant permission to",
	"mission.permission.user.selection.description": "Start typing to search for an user with the given nickname, including partial matches",
	"mission.registration.comment": "Comment",
	"mission.registration.comment.description": "Optional comment to the mission creator (max. 128 char)",
	"mission.registration.comment.optional": "Comment <em>(optional)</em>",
	"mission.registration.confirmed": "Confirmed",
	"mission.registration.registered": "Registered",
	"mission.repository.kind": "Type",
	"mission.repository.kind.arma3sync": "ArmA3Sync",
	"mission.repository.kind.description": "Defined the type of mod repository. Clicking an <code>ArmA3Sync</code> repository link automatically copies it to clipboard",
	"mission.repository.kind.other": "Other",
	"mission.repository.list": "Mod repositories",
	"mission.repository.list.empty": "No mod repositories required",
	"mission.repository.name": "Name",
	"mission.repository.name.description": "Name of the mod repository, mostly useful for searching in repo lists",
	"mission.repository.name.optional": "Name <em>(optional)</em>",
	"mission.repository.name.required": "Name",
	"mission.repository.notes": "Notes",
	"mission.repository.notes.description": "Optional notes about a repository, e.g. explaining the usage or required files. Required if no URL is provided",
	"mission.repository.notes.optional": "Notes <em>(optional)</em>",
	"mission.repository.url": "URL",
	"mission.repository.url.description": "URL of the mod repository. Required for <code>ArmA3Sync</code> repos, optional for others",
	"mission.repository.url.empty": "no repo URL provided",
	"mission.repository.url.optional": "URL <em>(optional)</em>",
	"mission.repositoryUrl": "Repository URL",
	"mission.repositoryUrl.description": "Can either be empty (if not required), a single URL to your repository or multiple links, including custom HTML formatting",
	"mission.repositoryUrl.optional": "Repository URL <em>(optional)</em>",
	"mission.requiredDLCs": "Required DLCs",
	"mission.requiredDLCs.aow": "Art of War",
	"mission.requiredDLCs.apex": "Apex",
	"mission.requiredDLCs.contact": "Contact",
	"mission.requiredDLCs.csla": "CSLA Iron Curtain",
	"mission.requiredDLCs.gm": "Global Mobilization",
	"mission.requiredDLCs.helicopters": "Helicopters",
	"mission.requiredDLCs.jets": "Jets",
	"mission.requiredDLCs.karts": "Karts",
	"mission.requiredDLCs.laws-of-war": "Laws of War",
	"mission.requiredDLCs.marksmen": "Marksmen",
	"mission.requiredDLCs.none": "no DLCs required",
	"mission.requiredDLCs.tac-ops": "Tac-Ops",
	"mission.requiredDLCs.tanks": "Tanks",
	"mission.requiredDLCs.vn": "S.O.G. Prairie Fire",
	"mission.rules": "Rules",
	"mission.rules.description": "General rules and guidelines for players while participating - mission specific restrictions should be added as a detailed description",
	"mission.rules.optional": "Rules <em>(optional)</em>",
	"mission.serverInfo.hostname": "Hostname/IP",
	"mission.serverInfo.name": "Server name",
	"mission.serverInfo.password": "Password",
	"mission.serverInfo.port": "Port",
	"mission.slot.assign.force": "Force slot assignment",
	"mission.slot.assign.force.description": "Forcing a slot assignment removes the selected user from their current slot if they have been assigned already - furthermore, the user currently assigned to the selected slot will be removed",
	"mission.slot.assign.selection": "Search for user to assign to slot",
	"mission.slot.assign.selection.description": "Start typing to search for an user with the given nickname, including partial matches",
	"mission.slot.assignee.registration": "no registrations | registration | registrations",
	"mission.slot.autoAssignable.description": "Auto-assignable slots do not require a registration-confirmation by a mission editor, but will automatically be assigned to the first user that register for it",
	"mission.slot.autoAssignable.slot": "Auto-assignable slot",
	"mission.slot.blocked": "blocked - no registration possible",
	"mission.slot.blocked.description": "Blocked slots are not available for registration",
	"mission.slot.blocked.popover": "Blocked - this slot has been blocked by the mission creator and is not available for registration",
	"mission.slot.blocked.slot": "Blocked slot",
	"mission.slot.confirm.delete": "Delete slot?",
	"mission.slot.confirm.delete.selection": "Delete selected slots?",
	"mission.slot.confirm.unassign.selection": "Unassign selected slots?",
	"mission.slot.confirm.unregister": "Unregister from slot?",
	"mission.slot.description": "Description",
	"mission.slot.description.description": "Optional, short description of the slot, e.g. explaining the equipment or vehicle used - displayed in slotlist",
	"mission.slot.description.optional": "Description <em>(optional)</em>",
	"mission.slot.detailedDescription": "Detailed description",
	"mission.slot.detailedDescription.description": "Optional, more detailed description of the slot, adding more information about the responsibilities or tasks assigned - displayed in slot details",
	"mission.slot.detailedDescription.optional": "Detailed description <em>(optional)</em>",
	"mission.slot.difficulty": "Difficulty",
	"mission.slot.difficulty.advanced": "Advanced",
	"mission.slot.difficulty.beginner": "Beginner",
	"mission.slot.difficulty.description": "Difficulity of the slot, helping players choose a role",
	"mission.slot.difficulty.easy": "Easy",
	"mission.slot.difficulty.expert": "Expert",
	"mission.slot.difficulty.medium": "Medium",
	"mission.slot.externalAssignee.description": "You can set an external assignee to assign a slot to a player that is not a user of our website. A slot can only either be assigned to a user <em>or</em> an external assignee",
	"mission.slot.externalAssignee.optional": "External assignee <em>(optional)</em>",
	"mission.slot.insertAfter": "Insert new slot after",
	"mission.slot.insertAfter.description": "Select the position after which the new slot should be inserted",
	"mission.slot.insertAfter.top": "Top of list",
	"mission.slot.move": "Move slot",
	"mission.slot.move.description": "Move the slot to a new position",
	"mission.slot.moveAfter": "Show slot after",
	"mission.slot.moveAfter.description": "Select the position after which the slot should be displayed",
	"mission.slot.moveAfter.keep": "Keep current position",
	"mission.slot.orderNumber": "Order number",
	"mission.slot.orderNumber.description": "Used for sorting slot in the mission slotlist",
	"mission.slot.player": "Player",
	"mission.slot.registrations": "Registrations",
	"mission.slot.reserve": "reserve",
	"mission.slot.reserve.description": "Reserve slots will only be filled if all other slots have been taken before",
	"mission.slot.reserve.popover": "Reserve - only filled after other slots are taken",
	"mission.slot.reserve.regular": "regular",
	"mission.slot.reserve.slot": "Reserve slot",
	"mission.slot.restricted": "restricted to {communityInfo}",
	"mission.slot.restricted.description": "Restricted slots are not available to the public, but only to players of the selected community",
	"mission.slot.restricted.popover": "Restricted - only available to <strong>{communityInfo}</strong> members",
	"mission.slot.restricted.selection": "Search for community to restrict slot to",
	"mission.slot.restricted.selection.description": "Start typing to search for a community with the given name or tag, including partial matches",
	"mission.slot.restricted.slot": "Restricted slot",
	"mission.slot.restricted.unrestricted": "unrestricted",
	"mission.slot.role": "Role",
	"mission.slot.selection.actions": "Perform actions for 1 selected slot | Perform actions for {count} selected slots",
	"mission.slot.selection.edit": "Allows you to edit certain values of 1 selected slot.<br>Data omitted will not be modified, you can thus only edit the values you want changed and leave the rest empty/not selected. Unfortunately, the slot statuses <code>restricted</code>, <code>reserve</code>,<code>blocked</code> and <code>auto-assignable</code> can only be removed for one slot at a time.<br>The following slot is affected: | Allows you to edit certain values of {count} selected slots.<br>Data omitted will not be modified, you can thus only edit the values you want changed and leave the rest empty/not selected. Unfortunately, the slot statuses <code>restricted</code>, <code>reserve</code>, <code>blocked</code> and <code>auto-assignable</code> can only be removed for one slot at a time.<br>The following slots are affected: ",
	"mission.slot.selection.hint": "Select multiple slots at the same time by clicking on them while holding <kbd>CTRL</kbd>",
	"mission.slot.status": "Status",
	"mission.slot.title": "Title",
	"mission.slot.title.description": "Title of the slot as displayed in the mission's slotlist",
	"mission.slotGroup.confirm.delete": "Delete slot group?",
	"mission.slotGroup.description": "Description",
	"mission.slotGroup.description.description": "Optional, short description of the slot group, e.g. explaining the group's general task or callsign - displayed in slotlist",
	"mission.slotGroup.description.optional": "Description <em>(optional)</em>",
	"mission.slotGroup.insertAfter": "Insert new slot group after",
	"mission.slotGroup.insertAfter.description": "Select the position after which the new slot group should be inserted",
	"mission.slotGroup.insertAfter.top": "Top of list",
	"mission.slotGroup.move": "Move slot group",
	"mission.slotGroup.move.description": "Move the slot group to a new position",
	"mission.slotGroup.moveAfter": "Show slot group after",
	"mission.slotGroup.moveAfter.description": "Select the position after which the slot group should be displayed",
	"mission.slotGroup.moveAfter.keep": "Keep current position",
	"mission.slotGroup.orderNumber": "Order number",
	"mission.slotGroup.orderNumber.description": "Used for sorting slot groups in the mission slotlist",
	"mission.slotGroup.title": "Title",
	"mission.slotGroup.title.description": "Title of the slot group as displayed in the mission's slotlist",
	"mission.slotlist": "Slotlist",
	"mission.slotlist.filter": "Filter",
	"mission.slotlist.filter.assigned": "assigned",
	"mission.slotlist.filter.blocked": "blocked",
	"mission.slotlist.filter.hasRegistrations": "has registrations",
	"mission.slotlist.filter.open": "open",
	"mission.slotlist.filter.restricted": "restricted",
	"mission.slotsAutoAssignable": "Auto-assignable slots",
	"mission.slotsAutoAssignable.description": "Auto-assignable slots do not require a registration-confirmation by a mission editor, but will automatically be assigned to the first user that register for it. By enabling this setting, all slots created <strong>from this point on</strong> will be set to be auto-assignable - existing slots will not be affected",
	"mission.slotTemplate": "Slot template",
	"mission.slotTemplate.confirm.delete": "Delete slot template?",
	"mission.slotTemplate.confirm.save.slotlist": "Save template slotlist?",
	"mission.slotTemplate.confirm.unsavedChanges": "Do you really want to leave? Your unsaved template slotlist changes will be lost!",
	"mission.slotTemplate.creator.title": "Create new slot template",
	"mission.slotTemplate.creator.title.browser": "Slot template creator",
	"mission.slotTemplate.duplicate.description": "You can overwrite the slot template's title as well as visibility setting.<br>All data omitted will be replaced by the original slot templates's values.",
	"mission.slotTemplate.duplicate.title.description": "New, optional title to overwrite for duplicated slot template - can be omitted",
	"mission.slotTemplate.duplicate.visibility.description": "Defines visibility of duplicated slot template to other users, only allowing access to selected group",
	"mission.slotTemplate.feedback.title": "Please enter a slot template title",
	"mission.slotTemplate.feedback.visibility": "Please select a visibility setting",
	"mission.slotTemplate.filter": "Slot template filter",
	"mission.slotTemplate.filter.description": "Filter slot templates by title or creator name, including partial matches",
	"mission.slotTemplate.insertAfter": "Apply slot template after",
	"mission.slotTemplate.insertAfter.description": "Select the position after which the slot template should be applied",
	"mission.slotTemplate.list.counts.slots": "# of slots",
	"mission.slotTemplate.list.counts.slots.groups": "# of slot groups",
	"mission.slotTemplate.modal.duplicate": "Duplicate slot template",
	"mission.slotTemplate.modal.edit": "Edit slot template",
	"mission.slotTemplate.slotlist": "Template slotlist",
	"mission.slotTemplate.title.description": "Title of the slot template, displayed in slot template list and details",
	"mission.slotTemplate.visibility.community": "community members",
	"mission.slotTemplate.visibility.default": "unknown",
	"mission.slotTemplate.visibility.description": "Defines visibility of the slot template to other users, only allowing access to the selected group",
	"mission.slotTemplate.visibility.hidden": "template creator only",
	"mission.slotTemplate.visibility.private": "selected communities and users",
	"mission.slotTemplate.visibility.public": "everyone",
	"mission.slottingTime": "Slotting time",
	"mission.slottingTime.description": "Date and time the missions slotting starts at",
	"mission.slug": "Slug",
	"mission.slug.description": "Slug to use for mission URL, must be unique",
	"mission.startTime": "Start time",
	"mission.startTime.description": "Date and time the mission starts",
	"mission.techSupport": "Tech support",
	"mission.techSupport.description": "Optional information about tech support or checks provided before the mission",
	"mission.techSupport.optional": "Tech support <em>(optional)</em>",
	"mission.times": "Slotting time: {slotting}\nStart time: {start}\nEnd time (est.): {end}\nBriefing (ldrsp.): {briefing}",
	"mission.times.ical": "Slotting time: {slotting}\\nStart time: {start}\\nEnd time (est.): {end}\\nBriefing (ldrsp.): {briefing}",
	"mission.timezone": "All mission times are displayed in the <em>{timezone}</em> timezone",
	"mission.title": "Title",
	"mission.title.description": "Title of the mission, displayed in mission list and details",
	"mission.token": "Mission token",
	"mission.token.description": "Mission tokens can be used as an alternative, static authentication method for embedding missions into different websites or forums. By default, all public missions can be embedded without extra configuration, however missions that do not have a public visibility setting require a mission token for embedding.<br>On the contrary to regular user authentication, mission tokens do not expire and only grant access to this specific mission. The information returned is identical to what a regular user would receive - no mission editor or creator specific data is provided.<br>By clicking the <strong>Generate</strong> button, you can generate a new mission token. Please note that this invalidates any previous tokens.<br>Using the <strong>Delete</strong> button, you can completely remove all mission tokens and thus remove all options to embed a non-public mission.",
	"mission.token.notGeneratedYet": "not generated yet",
	"mission.visibility": "Visibility",
	"mission.visibility.community": "community members",
	"mission.visibility.default": "unknown",
	"mission.visibility.description": "Defines visibility of the mission to other users, only allowing access to selected group",
	"mission.visibility.hidden": "mission creator & editors only",
	"mission.visibility.private": "selected communities and users",
	"mission.visibility.public": "everyone",
	"mission.voiceComms": "Voice Comms",
	"mission.voiceComms.hostname.description": "Hostname/IP address of the voice comms server used for the mission",
	"mission.voiceComms.hostname.optional": "Voice comms hostname/IP <em>(optional)</em>",
	"mission.voiceComms.name.description": "Name of the voice comms server (e.g. in a server list) the mission will be held on. Leave empty if not relevant",
	"mission.voiceComms.name.optional": "Voice comms name <em>(optional)</em>",
	"mission.voiceComms.password.description": "Password for the voice comms server used for the mission. Leave empty if no password is required",
	"mission.voiceComms.password.optional": "Voice comms password <em>(optional)</em>",
	"mission.voiceComms.port.description": "Port of the voice comms server used for the mission",
	"mission.voiceComms.port.optional": "Voice comms port <em>(optional)</em>",
	"nav.about": "About",
	"nav.account": "Account",
	"nav.admin.panel": "Admin Panel",
	"nav.api": "API",
	"nav.communities": "Communities",
	"nav.home": "Home",
	"nav.imprint": "Imprint",
	"nav.login": "Login",
	"nav.logout": "Logout",
	"nav.missions": "Missions",
	"nav.missionSlotTemplates": "Slot templates",
	"nav.notifications": "Notifications",
	"nav.privacy": "Privacy",
	"nav.users": "Users",
	"notification.list.filter": "Filter",
	"notification.list.filter.seen": "Include seen notifications",
	"notification.notification": "Notification",
	"notification.received": "Received",
	"notification.seen": "Seen",
	"notification.suppress": "Suppress notifications",
	"notification.suppress.description": "By suppressing notifications, you can prevent spamming your users due to multiple, subsequent or minor updates. If this checkbox is ticked, no notification will be created for the action performed. Please note that \"destructive\" actions such as slot unassignments, permission removal or mission deletion cannot have their notifications suppressed",
	"notification.type.community.application.accepted": "Your application to the community <strong>{communityName}</strong> has been <span class='text-success font-weight-bold'>accepted</span>",
	"notification.type.community.application.deleted": "<strong>{userNickname}</strong> has <span class='text-danger font-weight-bold'>deleted</span> their application to your community <strong>{communityName}</strong>",
	"notification.type.community.application.denied": "Your application to the community <strong>{communityName}</strong> has been <span class='text-danger font-weight-bold'>denied</span>",
	"notification.type.community.application.new": "<strong>{userNickname}</strong> has <span class='text-success font-weight-bold'>applied</span> to your community <strong>{communityName}</strong>",
	"notification.type.community.application.removed": "You have been <span class='text-danger font-weight-bold'>removed</span> from your community <strong>{communityName}</strong> by a community recruiter",
	"notification.type.community.deleted": "Your community <strong>{communityName}</strong> has been <span class='text-danger font-weight-bold'>deleted</span> by its founder",
	"notification.type.community.permission.granted": "You have been <span class='text-success font-weight-bold'>granted</span> the <strong>{translatedPermission}</strong> permission for your community <strong>{communityName}</strong>",
	"notification.type.community.permission.revoked": "Your <strong>{translatedPermission}</strong> permission for your community <strong>{communityName}</strong> has been <span class='text-danger font-weight-bold'>revoked</span>",
	"notification.type.mission.deleted": "The mission <strong>{missionTitle}</strong> has been <span class='text-danger font-weight-bold'>deleted</span> by its creator",
	"notification.type.mission.permission.granted": "You have been <span class='text-success font-weight-bold'>granted</span> the <strong>{translatedPermission}</strong> permission for the mission <strong>{missionTitle}</strong>",
	"notification.type.mission.permission.revoked": "Your <strong>{translatedPermission}</strong> permission for the mission <strong>{missionTitle}</strong> has been <span class='text-danger font-weight-bold'>revoked</span>",
	"notification.type.mission.slot.assigned": "You have been <span class='text-success font-weight-bold'>assigned</span> as <strong>{slotTitle}</strong> in mission <strong>{missionTitle}</strong>",
	"notification.type.mission.slot.registration.new": "<strong>{userNicknameWithTag}</strong> has <span class='text-success font-weight-bold'>registered</span> for slot <strong>{slotTitle}</strong> for the mission <strong>{missionTitle}</strong>",
	"notification.type.mission.slot.unassigned": "Your assignment as <strong>{slotTitle}</strong> in mission <strong>{missionTitle}</strong> has been <span class='text-danger font-weight-bold'>removed</span>",
	"notification.type.mission.slot.unregistered": "<strong>{userNicknameWithTag}</strong> has <span class='text-danger font-weight-bold'>unregistered</span> from their slot <strong>{slotTitle}</strong> in mission <strong>{missionTitle}</strong>",
	"notification.type.mission.updated": "Mission <strong>{missionTitle}</strong> was updated by a mission editor",
	"rights.reserved": "All rights reserved",
	"store.addMissionAccess": "Adding mission access...",
	"store.addMissionAccess.error": "Failed to add mission access",
	"store.addMissionAccess.success": "Successfully added mission access",
	"store.addMissionPermission": "Adding mission permission...",
	"store.addMissionPermission.error": "Failed to add mission permission",
	"store.addMissionPermission.success": "Successfully added mission permission",
	"store.applySlotTemplateToMission": "Applying slot template to mission...",
	"store.applySlotTemplateToMission.error": "Failed to apply slot template to mission",
	"store.applySlotTemplateToMission.success": "Successfully applied slot template to mission",
	"store.applyToCommunity": "Applying to community...",
	"store.applyToCommunity.error": "Failed to apply to community",
	"store.applyToCommunity.success": "Successfully applied to community",
	"store.assignMissionSlot": "Assigning slot...",
	"store.assignMissionSlot.error": "Failed to assign slot",
	"store.assignMissionSlot.success": "Successfully assigned slot",
	"store.checkCommunitySlugAvailability.error": "Failed to check availability of community slug",
	"store.checkMissionSlugAvailability.error": "Failed to check availability of mission slug <strong>{payload}</strong>",
	"store.createCommunity": "Creating community...",
	"store.createCommunity.error": "Failed to create community",
	"store.createCommunity.success": "Successfully created community",
	"store.createCommunityPermission": "Creating community permission...",
	"store.createCommunityPermission.error": "Failed to create community permission",
	"store.createCommunityPermission.success": "Successfully created community permission",
	"store.createMission": "Creating mission...",
	"store.createMission.error": "Failed to create mission <strong>{title}</strong>",
	"store.createMission.success": "Successfully created mission <strong>{title}</strong>",
	"store.createMissionSlot": "Creating slot... | Creating {count} slots...",
	"store.createMissionSlot.error": "Failed to create slot | Failed to create {count} slots",
	"store.createMissionSlot.success": "Successfully created slot | Successfully created {count} slots",
	"store.createMissionSlotGroup": "Creating slot group...",
	"store.createMissionSlotGroup.error": "Failed to create slot group <strong>{slotGroupInfo}</strong>",
	"store.createMissionSlotGroup.success": "Successfully created slot group <strong>{slotGroupInfo}</strong>",
	"store.createMissionSlotTemplate": "Creating slot template...",
	"store.createMissionSlotTemplate.error": "Failed to create slot template <strong>{title}</strong>",
	"store.createMissionSlotTemplate.success": "Successfully created slot template <strong>{title}</strong>",
	"store.deleteAccount": "Deleting account...",
	"store.deleteAccount.error": "Failed to delete account",
	"store.deleteAccount.success": "Successfully deleted account",
	"store.deleteCommunity": "Deleting community...",
	"store.deleteCommunity.error": "Failed to delete community",
	"store.deleteCommunity.success": "Successfully deleted community",
	"store.deleteCommunityLogo": "Deleting logo...",
	"store.deleteCommunityLogo.error": "Failed to delete logo",
	"store.deleteCommunityLogo.success": "Successfully deleted logo",
	"store.deleteCommunityPermission": "Deleting community permission...",
	"store.deleteCommunityPermission.error": "Failed to delete community permission",
	"store.deleteCommunityPermission.success": "Successfully deleted community permission",
	"store.deleteMission": "Deleting mission...",
	"store.deleteMission.error": "Failed to delete mission <strong>{title}</strong>",
	"store.deleteMission.success": "Successfully deleted mission <strong>{title}</strong>",
	"store.deleteMissionAccess": "Deleting mission access...",
	"store.deleteMissionAccess.error": "Failed to delete mission access",
	"store.deleteMissionAccess.success": "Successfully deleted mission access",
	"store.deleteMissionBannerImage": "Deleting banner image...",
	"store.deleteMissionBannerImage.error": "Failed to delete banner image",
	"store.deleteMissionBannerImage.success": "Successfully deleted banner image",
	"store.deleteMissionPermission": "Deleting mission permission...",
	"store.deleteMissionPermission.error": "Failed to delete mission permission",
	"store.deleteMissionPermission.success": "Successfully deleted mission permission",
	"store.deleteMissionSlot": "Deleting slot...",
	"store.deleteMissionSlot.error": "Failed to delete slot <strong>{slotInfo}</strong>",
	"store.deleteMissionSlot.success": "Successfully deleted slot <strong>{slotInfo}</strong>",
	"store.deleteMissionSlotGroup": "Deleting slot group...",
	"store.deleteMissionSlotGroup.error": "Failed to delete slot group <strong>{title}</strong>",
	"store.deleteMissionSlotGroup.success": "Successfully deleted slot group <strong>{title}</strong>",
	"store.deleteMissionSlotRegistration": "Deleting slot registration...",
	"store.deleteMissionSlotRegistration.error": "Failed to delete slot registration",
	"store.deleteMissionSlotRegistration.success": "Successfully deleted slot registration",
	"store.deleteMissionSlotTemplate": "Deleting slot template...",
	"store.deleteMissionSlotTemplate.error": "Failed to delete slot template <strong>{title}</strong>",
	"store.deleteMissionSlotTemplate.success": "Successfully deleted slot template <strong>{title}</strong>",
	"store.deleteMissionToken": "Deleting mission token...",
	"store.deleteMissionToken.error": "Failed to delete mission token",
	"store.deleteMissionToken.success": "Successfully deleted mission token",
	"store.deleteSelectedMissionSlots": "Deleting 1 slot... | Deleting {count} slots...",
	"store.deleteSelectedMissionSlots.error": "Failed to delete one or multiple selected slots",
	"store.deleteSelectedMissionSlots.success": "Successfully deleted 1 slot | Successfully deleted {count} slots",
	"store.deleteUser": "Deleting user...",
	"store.deleteUser.error": "Failed to delete user",
	"store.deleteUser.success": "Successfully deleted user",
	"store.duplicateMission": "Duplicating mission...",
	"store.duplicateMission.error": "Failed to duplicate mission",
	"store.duplicateMission.success": "Successfully duplicated mission",
	"store.duplicateMissionSlotGroup": "Duplicating slot group...",
	"store.duplicateMissionSlotGroup.error": "Failed to duplicate slot group <strong>{slotGroupInfo}</strong>",
	"store.duplicateMissionSlotGroup.success": "Successfully duplicated slot group <strong>{slotGroupInfo}</strong>",
	"store.editAccount": "Updating account details...",
	"store.editAccount.error": "Failed to update account details",
	"store.editAccount.success": "Successfully updated account details",
	"store.editCommunity": "Updating community details...",
	"store.editCommunity.error": "Failed to update community details",
	"store.editCommunity.success": "Successfully updated community details",
	"store.editMission": "Editing mission...",
	"store.editMission.error": "Failed to edit mission <strong>{title}</strong>",
	"store.editMission.success": "Successfully edited mission <strong>{title}</strong>",
	"store.editMissionSlot": "Editing slot...",
	"store.editMissionSlot.error": "Failed to edit slot <strong>{slotInfo}</strong>",
	"store.editMissionSlot.success": "Successfully edited slot <strong>{slotInfo}</strong>",
	"store.editMissionSlotGroup": "Editing slot group...",
	"store.editMissionSlotGroup.error": "Failed to edit slot group",
	"store.editMissionSlotGroup.success": "Successfully edited slot group",
	"store.editMissionSlotTemplate": "Editing slot template...",
	"store.editMissionSlotTemplate.error": "Failed to edit slot template <strong>{title}</strong>",
	"store.editMissionSlotTemplate.success": "Successfully edited slot template <strong>{title}</strong>",
	"store.editSelectedMissionSlots": "Editing 1 slot... | Editing {count} slots...",
	"store.editSelectedMissionSlots.error": "Failed to edit one or multiple selected slots",
	"store.editSelectedMissionSlots.success": "Successfully edited 1 slot | Successfully edited {count} slots",
	"store.editUser": "Updating user details...",
	"store.editUser.error": "Failed to update user details",
	"store.editUser.success": "Successfully updated user details",
	"store.generateMissionToken": "Generating mission token...",
	"store.generateMissionToken.error": "Failed to generate mission token",
	"store.generateMissionToken.success": "Successfully generated mission token",
	"store.getAccountDetails": "Loading account details...",
	"store.getAccountDetails.error": "Failed to load account details",
	"store.getCommunities": "Loading communities...",
	"store.getCommunities.error": "Failed to load communities",
	"store.getCommunityApplications": "Loading community applications...",
	"store.getCommunityApplications.error": "Failed to load community applications",
	"store.getCommunityApplicationStatus": "Loading community application status...",
	"store.getCommunityApplicationStatus.error": "Failed to load community application status",
	"store.getCommunityDetails": "Loading community details...",
	"store.getCommunityDetails.error": "Failed to load community details",
	"store.getCommunityDetails.error.notFound": "A community with the slug <strong>{slug}</strong> was not found",
	"store.getCommunityMissions": "Loading community missions...",
	"store.getCommunityMissions.error": "Failed to load community missions",
	"store.getCommunityPermissions": "Loading community permissions...",
	"store.getCommunityPermissions.error": "Failed to load community permissions",
	"store.getCommunityRepositories": "Loading community mod repositories...",
	"store.getCommunityRepositories.error": "Failed to load community mod repositories",
	"store.getCommunityServers": "Loading community servers...",
	"store.getCommunityServers.error": "Failed to load community servers",
	"store.getLoginRedirectUrl.error": "Failed to get Steam SSO URL",
	"store.getMissionAccesses": "Loading mission access...",
	"store.getMissionAccesses.error": "Failed to load mission access",
	"store.getMissionDetails": "Loading mission details...",
	"store.getMissionDetails.error": "Failed to load mission details",
	"store.getMissionDetails.error.notFound": "A mission with the slug <strong>{slug}</strong> was not found or is not visible",
	"store.getMissionPermissions": "Loading mission permissions...",
	"store.getMissionPermissions.error": "Failed to load mission permissions",
	"store.getMissions": "Loading missions...",
	"store.getMissions.error": "Failed to load missions",
	"store.getMissionsForCalendar.error": "Failed to load missions for calendar",
	"store.getMissionSlotlist": "Loading mission slotlist...",
	"store.getMissionSlotlist.error": "Failed to load mission slotlist",
	"store.getMissionSlotRegistrations": "Loading slot registrations...",
	"store.getMissionSlotRegistrations.error": "Failed to load slot registrations for slot <strong>{slotInfo}</strong>",
	"store.getMissionSlotTemplateDetails": "Loading slot template details...",
	"store.getMissionSlotTemplateDetails.error": "Failed to load slot template details...",
	"store.getMissionSlotTemplates": "Loading slot templates...",
	"store.getMissionSlotTemplates.error": "Failed to load slot templates",
	"store.getMissionToken": "Loading mission token...",
	"store.getMissionToken.error": "Failed to load mission token",
	"store.getNotifications": "Loading notifications...",
	"store.getNotifications.error": "Failed to load notifications",
	"store.getUnseenNotificationCount.error": "Failed to load unseen notification count",
	"store.getUserDetails": "Loading user details...",
	"store.getUserDetails.error": "Failed to load user details",
	"store.getUserMissions": "Loading user missions...",
	"store.getUserMissions.error": "Failed to load user missions",
	"store.getUsers": "Loading users...",
	"store.getUsers.error": "Failed to load users",
	"store.modifyMissionSlotRegistration": "Editing slot registration...",
	"store.modifyMissionSlotRegistration.error": "Failed to edit slot registration",
	"store.modifyMissionSlotRegistration.success": "Successfully edited slot registration",
	"store.performLogin": "Logging in...",
	"store.performLogin.error": "Failed to perform login",
	"store.processCommunityApplication": "Processing community application...",
	"store.processCommunityApplication.accept": "accept",
	"store.processCommunityApplication.accepted": "accepted",
	"store.processCommunityApplication.denied": "denied",
	"store.processCommunityApplication.deny": "deny",
	"store.processCommunityApplication.error": "Failed to {action} community application for user <strong>{nickname}</strong>",
	"store.processCommunityApplication.success": "Successfullly {action} community application for user <strong>{nickname}</strong>",
	"store.refreshToken": "Refreshing authentication...",
	"store.refreshToken.error": "Failed to perform login",
	"store.registerForMissionSlot": "Registering for slot...",
	"store.registerForMissionSlot.error": "Failed to register for slot <strong>{slotInfo}</strong>",
	"store.registerForMissionSlot.success": "Successfully registered for slot <strong>{slotInfo}</strong>",
	"store.removeCommunityMember": "Removing community member...",
	"store.removeCommunityMember.error": "Failed to remove community member <strong>{nickname}</strong>",
	"store.removeCommunityMember.success": "Successfully removed community member <strong>{nickname}</strong>",
	"store.searchCommunities.error": "Failed to search communities",
	"store.searchMissions.error": "Failed to search missions",
	"store.searchUsers.error": "Failed to search users",
	"store.unassignSelectedMissionSlots": "Unassigning 1 slot... | Unassigning {count} slots...",
	"store.unassignSelectedMissionSlots.error": "Failed to unassign one or multiple selected slots",
	"store.unassignSelectedMissionSlots.success": "Successfully unassigned 1 slot | Successfully unassigned {count} slots",
	"store.unregisterFromMissionSlot": "Unregistering from slot...",
	"store.unregisterFromMissionSlot.error": "Failed to unregister from slot <strong>{slotInfo}</strong>",
	"store.unregisterFromMissionSlot.success": "Successfully unregistered from slot <strong>{slotInfo}</strong>",
	"store.uploadCommunityLogo": "Uploading logo...",
	"store.uploadCommunityLogo.error": "Failed to upload logo",
	"store.uploadCommunityLogo.success": "Successfully uploaded logo",
	"store.uploadMissionBannerImage": "Uploading banner image...",
	"store.uploadMissionBannerImage.error": "Failed to upload banner image",
	"store.uploadMissionBannerImage.success": "Successfully uploaded banner image",
	"title.browser": "ArmA 3 mission and slotlist management",
	"user": "User",
	"user.confirm.activate": "Activate user account?",
	"user.confirm.deactivate": "Deactivate user account?",
	"user.confirm.delete": "Delete user?",
	"user.list.search": "Search users",
	"user.list.search.description": "Start typing to search for an user with the given nickname, including partial matches. Clicking a user result will take you to their details page",
	"user.modal.edit": "Edit user details",
	"user.nickname": "Nickname",
	"user.status": "Status",
	"user.status.deactivated": "Account deactivated",
	"user.status.normal": "normal",
	"user.steamId": "Steam ID"
};


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en.json
// module id = 593
// module chunks = 0